{
  "defaultAuthor": "Xtreed member",
  "errors": {
    "accessToken": "Could not generate access.",
    "signIn": "Could not sign in to the community.",
    "noResponse": "The community did not respond."
  },
  "miniPlayer": {
    "size": "Video size",
    "sizeValue": "{{width}} pixels wide",
    "position": "Video position — use the arrow keys to move it",
    "lesson": "Lesson",
    "backToLesson": "Back to lesson"
  },
  "nav": {
    "loading": "Loading community spaces",
    "loadError": "Couldn't load the community spaces. Try reloading the page.",
    "empty": "No spaces available to you yet.",
    "label": "Community spaces",
    "postCount_one": "{{count}} post",
    "postCount_zero": "{{count}} posts",
    "postCount_other": "{{count}} posts",
    "lessonTag": "Lesson",
    "locked": "Locked space"
  },
  "list": {
    "pinned": "Pinned",
    "special": {
      "lockedTitle": "Restricted space",
      "calendarTitle": "Calendar space",
      "materialsTitle": "Materials space",
      "lockedDescription": "You don't have access to this space yet. It has to be opened in the community.",
      "unsupportedDescription": "This type of space doesn't open inside the lesson — open the community to see the full content."
    },
    "empty": {
      "title": "No conversations here yet",
      "description": "Get it started: post your question about the lesson or show what you've just built."
    },
    "unavailable": "Space unavailable.",
    "postFooter": "_Posted from the lesson [{{title}}]({{url}})._",
    "published": "Posted!",
    "conversations_one": "{{count}} conversation",
    "conversations_zero": "{{count}} conversations",
    "conversations_other": "{{count}} conversations",
    "compose": {
      "titlePlaceholder": "Post title",
      "bodyPlaceholder": "Tell us what's going on, paste the code, describe the error...",
      "cancel": "Cancel",
      "publish": "Post",
      "publishIn": "Post in {{space}}"
    }
  },
  "conversation": {
    "removedAuthor": "Removed",
    "replied": "Reply posted!",
    "none": {
      "title": "No conversation open",
      "description": "Pick a conversation from the list to read the whole discussion and reply here."
    },
    "loadError": {
      "title": "Couldn't load this conversation",
      "description": "The community may be briefly down. Try opening it again in a moment."
    },
    "reactWith": "React with {{emoji}}",
    "replies": "Replies",
    "noReplies": "No one has replied yet. Yours could be the first.",
    "yourReply": "Your reply",
    "replyPlaceholder": "Write your reply…",
    "markdownHint": "Basic Markdown works here.",
    "reply": "Reply",
    "closed": "This conversation isn't accepting new replies."
  },
  "dock": {
    "community": "Community",
    "someone": "Someone",
    "replies_one": "{{count}} reply",
    "replies_zero": "{{count}} replies",
    "replies_other": "{{count}} replies",
    "openPrompt": "Open to chat with your classmates",
    "label": "Xtreed Community",
    "back": "Back",
    "showSpaces": "View community spaces",
    "openFull": "Open full view",
    "backToLesson": "Back to lesson",
    "spaces": "Spaces",
    "closeSpaces": "Close spaces"
  }
}
